export default __webpack_public_path__ + "static/media/go.36ed9820.svg";